var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6193_47827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0001C2 13.9779 2.58649 15.9113 3.6853 17.5558C4.78412 19.2003 6.3459 20.482 8.17317 21.2389C10.0004 21.9957 12.0111 22.1938 13.9509 21.8079C15.8907 21.4221 17.6725 20.4697 19.0711 19.0711C20.4696 17.6726 21.422 15.8908 21.8079 13.951C22.1937 12.0112 21.9957 10.0005 21.2388 8.17323C20.4819 6.34597 19.2002 4.78418 17.5557 3.68536C15.9112 2.58655 13.9778 2.00006 12 2.00006C10.6868 2.00006 9.38642 2.25872 8.17317 2.76127C6.95991 3.26381 5.85752 4.00041 4.92893 4.92899C3.05357 6.80436 2 9.3479 2 12.0001V12.0001ZM13.86 8.31006L16.72 11.3101C16.7623 11.3534 16.7962 11.4043 16.82 11.4601C16.8625 11.5071 16.8963 11.5613 16.92 11.6201C16.9729 11.7398 17.0002 11.8692 17.0002 12.0001C17.0002 12.1309 16.9729 12.2604 16.92 12.3801C16.8724 12.5028 16.801 12.615 16.71 12.7101L13.71 15.7101C13.5217 15.8984 13.2663 16.0042 13 16.0042C12.7337 16.0042 12.4783 15.8984 12.29 15.7101C12.1017 15.5218 11.9959 15.2664 11.9959 15.0001C11.9959 14.7338 12.1017 14.4784 12.29 14.2901L13.59 13.0001H8C7.73478 13.0001 7.48043 12.8947 7.29289 12.7072C7.10536 12.5196 7 12.2653 7 12.0001C7 11.7348 7.10536 11.4805 7.29289 11.293C7.48043 11.1054 7.73478 11.0001 8 11.0001H13.66L12.41 9.69006C12.227 9.49778 12.1279 9.24068 12.1344 8.97531C12.141 8.70995 12.2527 8.45806 12.445 8.27506C12.6373 8.09206 12.8944 7.99294 13.1597 7.99951C13.4251 8.00607 13.677 8.11778 13.86 8.31006V8.31006Z",
    fill: "url(#paint0_linear_6193_47827)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6193_47827",
    x1: 21.4118,
    y1: 5.03577,
    x2: 1.04703,
    y2: 6.57735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BC9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FFEEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#D6BC9E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6193_47827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleRightArrow);
export default __webpack_public_path__ + "static/media/icon-circle-right-arrow.8f6e6f03f6581248a0c08e1b2fa67051.svg";
export { ForwardRef as ReactComponent };